import React, { useEffect, useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
  TextField,
  IconButton,
  Tooltip,
  Paper,
  Grid,
} from "@material-ui/core"
import { Add, Close, Remove } from "@material-ui/icons"
import { compose } from "recompose"
import { connect } from "react-redux"
import { getParentChildRoles } from "../../actions/roles"
import { isEmpty, head } from "lodash"
import AutoComplete from "../AutoComplete"
import update from "immutability-helper"
import LoadingButton from "../LoadingButton"
import {
  createShootGlue,
  createCalendars,
  updateCalendars,
  toggleRoleDialog,
  getShootbyId,
  setCurrentShoot,
  recallShoot,
} from "../../actions/shoots"
import { getCrew } from "../../actions/crew"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Badge from "@material-ui/core/Badge"
import { publishPostByCompany } from "../../actions/misc"
import moment from "moment"
import { convertToAbbr } from "../../lib/states"
import { getCurrentHost } from "../../utils/getHost"
import { CircularProgress } from "../../../node_modules/@material-ui/core/index"
import { withRouter } from "react-router"
import { openSnackBar } from "../../actions/snack-bar"

const defaultState = {
  shoot: {
    name: "",
    client: null,
    call_time: null,
    start_date: new Date(),
    end_date: new Date(),
    day: "full",
    roles: [],
    newPosition: {
      switch: false,
      client_rate: 0,
      crew_rate: 0,
      available: false,
      requested: false,
    },
    location: null,
    firm: false,
    defaultCrews: [],
    timezone: "Eastern Time",
    forward_facing_text: "",
    creator_text: "",
    published: null,
  },
  rolesCount: [],
  saving: false,
  activeCompany: null,
  inCompany: false,
  positionRef: null,
  setClient: newClient => {
    this.shoot.client = newClient
  },
  children: [],
  mergeSelection: [],
  apiData: {},
  dialogOpen: false,
  mergedRoles: null,
  working: false,
  parentRolesSuggestion: [],
  childRoles: [],
  selectedParentRole: null,
  anchorEl: "add-position-input",
}

class AddRoleDialog extends React.Component {
  state = defaultState

  async componentDidUpdate(prevProps) {
    if (prevProps.open === false && this.props.open === true) {
      if (this.props.shootId) {
        await this.setRolesSuggestion()

        const shoot = this.props.shoots.find(
          x => x.id === Number(this.props.shootId)
        )
        this.setState(
          update(this.state, {
            shoot: {
              id: {
                $set: this.props.shootId,
              },
              location: {
                $set: shoot.location,
              },
              published: {
                $set: shoot.published,
              },
            },
          })
        )
      }
    }
  }

  async componentDidMount() {
    await this.props.dispatch(getParentChildRoles())

    this.setRolesSuggestion()
  }

  setRolesSuggestion = () => {
    const { childParentRoles } = this.props

    let parentRolesSuggestion = []
    childParentRoles &&
      childParentRoles.parents &&
      !isEmpty(childParentRoles.connections) &&
      childParentRoles.parents.map(
        p =>
          childParentRoles.connections.find(x => x.parent_role_id == p.id) &&
          parentRolesSuggestion.push({ id: p.id, name: p.name, rate: null })
      )

    this.setState({
      parentRolesSuggestion: parentRolesSuggestion,
    })
  }

  selectAndAddPosition = id => {
    const { roles } = this.props
    const { shoot, rolesCount } = this.state
    const role = roles.find(x => x.id == id)
    const checkRole =
      !isEmpty(shoot.roles) && shoot.roles.find(x => x.position.id == id)

    if (checkRole) {
      let indexRole = rolesCount.findIndex(x => x.id == id)
      this.setState(
        update(this.state, {
          shoot: {
            roles: {
              $push: [
                {
                  client_rate: null,
                  crew_rate: null,
                  switch: null,
                  position: role,
                },
              ],
            },
          },
          rolesCount: {
            [indexRole]: {
              count: { $set: this.state.rolesCount[indexRole].count + 1 },
            },
          },
        })
      )
    } else {
      this.setState(
        update(this.state, {
          shoot: {
            roles: {
              $push: [
                {
                  client_rate: null,
                  crew_rate: null,
                  switch: null,
                  position: role,
                },
              ],
            },
          },
          rolesCount: {
            $push: [
              {
                id: role.id,
                name: role.name,
                count: 1,
              },
            ],
          },
        })
      )
    }

    this.setState({ anchorEl: "none" })
  }

  removePosition = (id, index) => {
    const { roles } = this.props
    const { shoot, rolesCount } = this.state
    const role = roles.find(x => x.id == id)
    const checkRole = !isEmpty(rolesCount) && rolesCount.find(x => x.id == id)

    let indexRole = shoot.roles.findIndex(x => x.position.id == id)
    let indexRoleCount =
      !isEmpty(rolesCount) && rolesCount.findIndex(x => x.id == id)

    if (checkRole.count > 1) {
      this.setState(
        update(this.state, {
          shoot: {
            roles: {
              $splice: [[indexRole, 1]],
            },
          },
          rolesCount: {
            [index]: {
              count: { $set: this.state.rolesCount[index].count - 1 },
            },
          },
        })
      )
    } else {
      this.setState(
        update(this.state, {
          shoot: {
            roles: {
              $splice: [[indexRole, 1]],
            },
          },
          rolesCount: {
            $splice: [[indexRoleCount, 1]],
          },
        })
      )
    }

    this.setState({ anchorEl: "none" })
  }

  selectParentRole = async id => {
    const { childParentRoles } = this.props
    const { parentRolesSuggestion } = this.state
    const selectedParentRole = parentRolesSuggestion.find(x => x.id == id)
    let child = childParentRoles.connections
      .map(
        x =>
          x.parent_role_id == id
            ? childParentRoles.children.find(y => x.child_role_id === y.id)
            : null
      )
      .filter(el => el != null)
    await this.setState({
      childRoles: child,
    })
    let roleNames = []
    child && child.map(c => roleNames.push(c.name))

    this.setState({
      selectedParentRole: selectedParentRole,
    })
  }

  onClose = async () => {
    await this.setState({
      shoot: {
        name: "",
        client: null,
        call_time: null,
        start_date: new Date(),
        end_date: new Date(),
        day: "full",
        roles: [],
        newPosition: {
          switch: false,
          client_rate: 0,
          crew_rate: 0,
          available: false,
          requested: false,
        },
        location: null,
        firm: false,
        defaultCrews: [],
        timezone: "Eastern Time",

        forward_facing_text: "",
        creator_text: "",
      },
      saving: false,
      activeCompany: null,
      inCompany: false,
      positionRef: null,
      setClient: newClient => {
        this.shoot.client = newClient
      },
      children: [],
      mergeSelection: [],
      apiData: {},
      dialogOpen: false,
      mergedRoles: null,
      working: false,
      parentRolesSuggestion: [],
      childRoles: [],
      selectedParentRole: null,
    })

    if (this.props.shootId && !window.location.pathname.includes("billing")) {
      const shoot = this.props.shoots.find(x => x.id === this.props.shootId)
      shoot.roles.forEach(role => {
        if (role.user_id) {
          this.props.dispatch(getCrew(role.user_id))
        }
      })
    }

    this.props.dispatch(toggleRoleDialog({ open: false, id: null }))
  }

  update = () => {
    let shootId = window.location.pathname.match(/\d+/g).map(Number)

    const { state } = this
    const { shoot, rolesCount } = state
    this.setState({ saving: true })
    let data = shoot.roles
      .map(x => {
        return {
          user_id: null,
          role_id: x.position.id,
          client_rate: x.client_rate || 0,
          crew_rate: x.crew_rate || 0,
          available: false,
          requested: false,
        }
      })
      .concat(
        shoot.defaultCrews.map(x => {
          return {
            user_id: x.id,
            role_id: x.shootRole.id,
            client_rate: x.shootRole.client_rate,
            crew_rate: x.shootRole.crew_rate,
            available: x.shootRole.available,
            requested: x.shootRole.requested,
          }
        })
      )

    const newPosition = shoot.newPosition
    if (
      !newPosition.position ||
      (!newPosition.crew_rate && newPosition.crew_rate !== 0) ||
      Number(newPosition.crew_rate) < 0 ||
      (!newPosition.client_rate && newPosition.client_rate !== 0) ||
      Number(newPosition.client_rate) < 0
    ) {
    } else {
      data = data.concat([
        {
          role_id: newPosition.position.id,
          client_rate: newPosition.client_rate,
          crew_rate: newPosition.crew_rate,
          user_id:
            newPosition.user && newPosition.user.id
              ? newPosition.user.id
              : null,
          requested: newPosition.requested,
          available: newPosition.available,
        },
      ])
    }

    const promiseArr = data.map(role =>
      this.props.dispatch(createShootGlue(shoot.id, "roles", role))
    )

    Promise.all(promiseArr)
      .then(res => {
        // debugger;
        this.props.dispatch(createCalendars(shoot.id))
        this.props.dispatch(updateCalendars(shoot.id))
      })
      .then(res => {
        if (shoot.published == 1) {
          // this.postOnTwitter(rolesCount)
          // Not 100% sure what's going on here. I was trying to add a role to a shoot
          // and it kept ending up going into here, which is just trying to post to twitter,
          // which isn't even working. I added the two lines below to make the role modal go away
          // and to make the role appear on the deal memo card without refreshing
          this.props.dispatch(toggleRoleDialog({ open: false, id: null }))
          this.props.dispatch(recallShoot(true))
          this.props.dispatch(openSnackBar({ message: "New Role Added" }))
          // COULD POSSIBLY BE WRONG. This isn't necessarily the solution but it's working for now
        } else {
          this.setState({ saving: false })
          if (window.location.pathname.includes("billing")) {
            // window.location.href = `/shoots/${shoot.id}/billing/deal-memo`
            this.props.history.push(`/shoots/${shoot.id}/billing/deal-memo`)
          } else if (this.props.activeCompany) {
            // window.location.href = `/shoots/${shoot.id}`
            this.props.history.push(`/shoots/${shoot.id}`)
          } else {
            this.props
              .dispatch(getShootbyId(shootId))
              .then(res => {
                this.props.dispatch(toggleRoleDialog({ open: false, id: null }))
                this.setState(defaultState)
              })
              .catch(err => {
                console.log(err)
              })
            this.props.history.push(`/my-shoots/${shoot.id}`)
          }
        }
      })
  }

  countRolesOccurence = role => {
    const { shoot } = this.state

    return shoot.roles.reduce((n, x) => n + (x.position.id === role), 0)
  }

  postOnTwitter = addedPositions => {
    const { roles, activeCompany, authenticatedUser } = this.props

    const { shoot } = this.state
    if (addedPositions && addedPositions.length > 0) {
      addedPositions.forEach(async (position, index) => {
        let role = roles.find(x => x.id == position.id)

        // let twitterPost = {
        //   companyId: activeCompany || 2,
        //   postBody: `New shoot open!\r\n\r\nPosition: ${role.name
        //     }\r\nLocation: ${shoot.location.city}, ${head(shoot.location.state) &&
        //     head(convertToAbbr(shoot.location.state)).abbr}\r\nDate: ${moment(
        //       shoot.start_date
        //     ).format("MMM DD, YYYY")}\r\n\r\nApply Here: https://crewmama.com/gigs`,
        // }

        let twitterPost = {
          companyId: activeCompany || 2,
          postBody: `New shoot open!\r\n\r\nPosition: ${
            role.name
          }\r\nLocation: ${shoot.location.city},\r\nDate: ${moment(
            shoot.start_date
          ).format(
            "MMM DD, YYYY"
          )}\r\n\r\nApply Here: https://crewmama.com/gigs`,
        }
        await this.props.dispatch(
          publishPostByCompany(authenticatedUser.id, twitterPost)
        )
      })
    }
    // this.setState({ saving: false })
    if (window.location.pathname.includes("billing")) {
      // window.location.href = `/shoots/${shoot.id}/billing/deal-memo`

      this.props.history.push(`/shoots/${shoot.id}/billing/deal-memo`)
    } else if (activeCompany) {
      // window.location.href = `/shoots/${shoot.id}`
      // this.props.history.push(`/shoots/${shoot.id}`)
      this.props
        .dispatch(getShootbyId(shoot.id))
        .then(res => {
          const shootObj = res.find(item => item.id === shoot.id)
          this.props.setNewShoot(shootObj)
          this.props.dispatch(toggleRoleDialog({ open: false, id: null }))
          this.setState(defaultState)
        })
        .catch(err => {
          console.log(err)
        })
    } else {
      this.setState(defaultState)

      this.props.history.push(`/my-shoots/${shoot.id}`)
    }
  }

  render() {
    const { open, fullScreen, classes, activeCompany, companies } = this.props
    const {
      parentRolesSuggestion,
      selectedParentRole,
      shoot,
      anchorEl,
      rolesCount,
    } = this.state

    return (
      <Dialog
        open={open}
        onClose={() => this.onClose()}
        fullScreen={fullScreen}
      >
        <DialogContent
          style={{
            backgroundColor:
              getCurrentHost() === "crewmama" ? "#F04031" : "#5241a3",
          }}
        >
          <Typography variant="h6" style={{ color: "#ffffff" }}>
            Add Roles
          </Typography>
        </DialogContent>
        <DialogContent className={classes.responsiveDialogContent}>
          <Grid container>
            <Grid
              item
              lg={5}
              sm={12}
              xs={12}
              className={classes.roleSelectionArea}
              style={{
                backgroundColor: "#f6f6fe",
                minHeight: "400px",
              }}
            >
              <div
                style={{
                  minWidth: "200px",
                  display: "flex",
                  marginTop: "10px",
                  marginLeft: "10px",
                }}
              >
                {parentRolesSuggestion.length === 0 ? (
                  <Box display="flex" justifyContent="center" width="100%">
                    <CircularProgress size={20} />
                  </Box>
                ) : (
                  <AutoComplete
                    placeholder="Search Role"
                    onChange={this.selectParentRole}
                    suggestions={parentRolesSuggestion}
                    labelKey="name"
                    blurInputOnSelect
                    backspaceRemovesValue
                    showValue
                    value={selectedParentRole}
                    id="add-position-input"
                    prop={this.props}
                    autoFocus={anchorEl === "add-position-input" ? true : false}
                    onClick={() =>
                      this.setState({ anchorEl: "add-position-input" })
                    }
                  />
                )}
              </div>
              {this.state.childRoles &&
                !isEmpty(this.state.childRoles) && (
                  <Box
                    width="100%"
                    marginBottom="200px"
                    marginTop="10px"
                    style={{
                      paddingLeft: "20px",
                    }}
                  >
                    {this.state.childRoles.map((role, index) => {
                      if (!isEmpty(shoot.roles)) {
                        const roleCheck = shoot.roles.find(
                          r => r.position.id === role.id
                        )
                        return roleCheck ? null : (
                          <Box
                            display="flex"
                            alignItems="center"
                            style={{ justifyContent: "space-between" }}
                          >
                            <Typography variant="h8" color="#2d3e51">
                              {role.name}
                            </Typography>
                            <Tooltip title="Add Role" placement="top">
                              <IconButton
                                style={{ padding: "5px" }}
                                onClick={() =>
                                  this.selectAndAddPosition(role.id)
                                }
                              >
                                <Add color="primary" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        )
                      } else {
                        return (
                          <Box
                            display="flex"
                            alignItems="center"
                            style={{ justifyContent: "space-between" }}
                          >
                            <Typography variant="h8" color="#2d3e51">
                              {role.name}
                            </Typography>
                            <Tooltip title="Add Role" placement="top">
                              <IconButton
                                style={{ padding: "5px" }}
                                onClick={() =>
                                  this.selectAndAddPosition(role.id)
                                }
                              >
                                <Add color="primary" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        )
                      }
                    })}
                  </Box>
                )}
            </Grid>
            <Grid item sm={12} lg={6} xs={12}>
              {shoot.roles &&
                !isEmpty(shoot.roles) && (
                  <Box
                    width="100%"
                    marginBottom="200px"
                    marginTop="10px"
                    style={{
                      paddingLeft: "20px",
                    }}
                  >
                    <Typography
                      variant="h8"
                      style={{ padding: "20px" }}
                      color="#2d3e51"
                    >
                      Added Roles ({shoot.roles.length})
                    </Typography>
                    {rolesCount &&
                      !isEmpty(rolesCount) &&
                      rolesCount.map((role, index) => (
                        <Badge badgeContent={role.count} color="primary">
                          <Paper
                            elevation={3}
                            style={{
                              margin: "10px",
                              padding: "10px",
                              display: "flex",
                              justifyContent: "space-between",
                              minWidth: "280px",
                            }}
                            Key={`merge-role-${index + 1}`}
                          >
                            <Typography
                              component="p"
                              style={{ fontSize: "0.9em" }}
                            >
                              {role.name}
                            </Typography>
                            <div style={{ display: "flex" }}>
                              <Tooltip title="Add Role" placement="top">
                                <IconButton
                                  style={{ padding: 0 }}
                                  onClick={() =>
                                    this.selectAndAddPosition(role.id)
                                  }
                                >
                                  <Add color="primary" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Remove Role" placement="top">
                                <IconButton
                                  style={{ padding: 0 }}
                                  onClick={() =>
                                    this.removePosition(role.id, index)
                                  }
                                >
                                  {role.count > 1 ? (
                                    <Remove color="primary" />
                                  ) : (
                                    <Close color="primary" />
                                  )}
                                </IconButton>
                              </Tooltip>
                            </div>
                          </Paper>
                        </Badge>
                      ))}
                  </Box>
                )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            onClick={() => this.onClose()}
            color="secondary"
          >
            Close
          </Button>
          <Box />
          <LoadingButton
            variant="contained"
            color="primary"
            onClick={this.update}
            disabled={isEmpty(shoot.roles)}
            working={this.state.saving}
          >
            Add
            {shoot.roles && !isEmpty(shoot.roles) && `(${shoot.roles.length})`}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    open: state.shoots.roleDialog,
    shootId: state.shoots.dialogShootId,
    shoots: state.shoots.shoots,
    childParentRoles: state.misc.childParentRoles,
    roles: state.misc.roles,
    activeCompany: state.companies.activeCompany,
    authenticatedUser: state.authentication.authenticatedUser,
  }
}

export default withRouter(
  compose(
    connect(mapStateToProps),
    withStyles(styles, { withTheme: true }),
    withMobileDialog()
  )(AddRoleDialog)
)
